import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const TransactionsGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.25 2.5C5.01625 2.5 4 3.51625 4 4.75V16.5H3.25C3.05109 16.5 2.86034 16.579 2.71969 16.7197C2.57904 16.8603 2.50002 17.0511 2.5 17.25V18.25C2.5 20.036 3.96403 21.5 5.75 21.5H16.75C18.536 21.5 20 20.036 20 18.25V4.75C20 3.51625 18.9838 2.5 17.75 2.5H6.25ZM8.25 6.5C8.664 6.5 9 6.836 9 7.25C9 7.664 8.664 8 8.25 8C7.836 8 7.5 7.664 7.5 7.25C7.5 6.836 7.836 6.5 8.25 6.5ZM10.75 6.5H15.75C16.1645 6.5 16.5 6.8355 16.5 7.25C16.5 7.6645 16.1645 8 15.75 8H10.75C10.3355 8 10 7.6645 10 7.25C10 6.8355 10.3355 6.5 10.75 6.5ZM8.25 9.5C8.664 9.5 9 9.836 9 10.25C9 10.664 8.664 11 8.25 11C7.836 11 7.5 10.664 7.5 10.25C7.5 9.836 7.836 9.5 8.25 9.5ZM10.75 9.5H15.75C16.1645 9.5 16.5 9.8355 16.5 10.25C16.5 10.6645 16.1645 11 15.75 11H10.75C10.3355 11 10 10.6645 10 10.25C10 9.8355 10.3355 9.5 10.75 9.5ZM8.25 12.5C8.664 12.5 9 12.836 9 13.25C9 13.664 8.664 14 8.25 14C7.836 14 7.5 13.664 7.5 13.25C7.5 12.836 7.836 12.5 8.25 12.5ZM10.75 12.5H15.75C16.1645 12.5 16.5 12.8355 16.5 13.25C16.5 13.6645 16.1645 14 15.75 14H10.75C10.3355 14 10 13.6645 10 13.25C10 12.8355 10.3355 12.5 10.75 12.5ZM4 18H13.5V18.25C13.5 18.9075 13.747 19.4867 14.0869 20H5.75C4.77497 20 4 19.225 4 18.25V18Z"
        fill="#286AF6"
      />
    </CustomSvg>
  );
};

export default TransactionsGe;
